import { ENotificationType } from "../interfaces";
import { useWatchBaseNotification, type IUseWatchBaseNotificationProps } from "./useWatchBaseNotification";

export type TimeSheetNotificationPayload = {
  uid: string;
};

export const useWatchTimeSheetNotifications = ({
  dissableSnackbarAlert = false,
  onNotificationArrived,
}: Omit<IUseWatchBaseNotificationProps<TimeSheetNotificationPayload>, "notificationTypes" | "buildSnackbarMessage"> = {}) =>
  useWatchBaseNotification<TimeSheetNotificationPayload>({
    notificationTypes: [ENotificationType.JobPunched],
    dissableSnackbarAlert,
    onNotificationArrived,
    buildSnackbarMessage: (msg) => `Job ${msg?.meta?.uid} punched`,
  });
